import { clsx } from 'clsx';
import { HtmlHTMLAttributes } from 'react';

import './TextTertiary.css';

export type TextTertiaryProps = HtmlHTMLAttributes<HTMLSpanElement>;

export const TextTertiary = ({ className, ...textProps }: TextTertiaryProps) => {
  return <span className={clsx('text-tertiary', className)} {...textProps} />;
};
